import { IntlShape } from 'react-intl'

import { ADDRESSES } from 'Constants/constants'
import { getPortalConfig_portalConfigStoreForUserAndOrg } from 'Constants/graphql/queries/detail/__generated__/getPortalConfig'
import { getRental_rental } from 'Constants/graphql/queries/detail/__generated__/getRental'
import { getOrganisation_organisation } from 'Constants/graphql/queries/organisation/__generated__/getOrganisation'

import { ShippingAddressTypeEnum } from 'Types/address/address.types'
import { RadioButton } from 'Types/modalTypes'

import { splitStreetNumber } from '../form/form.util'
import { getFullContactName } from '../getFullContactName/getFullContactName.util'

export const getRadioButtons = (
  intl: IntlShape,
  organisation: getOrganisation_organisation | null,
  portalConfig: getPortalConfig_portalConfigStoreForUserAndOrg | null,
  rental: getRental_rental,
) => {
  const radioButtons: RadioButton[] = []

  if (
    rental.organisation &&
    rental.organisation.contact &&
    rental.organisation.contact.address &&
    portalConfig?.shipToOfficeAddress
  ) {
    const { address } = rental.organisation.contact

    radioButtons.push({
      label: `${rental.organisation.shortName} Office`,
      shippingAddress: {
        city: address.city,
        co: address.nameAddition,
        country: address.country,
        id: address.id,
        postcode: address.zipcode,
        to: rental.organisation.fullName,
        type: ShippingAddressTypeEnum.OFFICE,
        ...splitStreetNumber(address.street || ''),
      },
      shippingAddressCanBeEdited: true,
    })
  } else if (
    organisation?.contact?.address &&
    portalConfig?.shipToOfficeAddress
  ) {
    const { address } = organisation.contact

    radioButtons.push({
      label: `${organisation.shortName} Office`,
      shippingAddress: {
        city: address.city,
        co: address.nameAddition,
        country: address.country,
        id: address.id,
        postcode: address.zipcode,
        to: organisation.fullName,
        type: ShippingAddressTypeEnum.OFFICE,
        ...splitStreetNumber(address.street || ''),
      },
      shippingAddressCanBeEdited: true,
    })
  }

  if (rental.employee?.office?.address) {
    const { employee } = rental
    const { address } = rental.employee.office

    let co

    if (address.nameAddition !== '') {
      if (employee.contact.firstName) {
        co = `${address.nameAddition} - ${getFullContactName(employee.contact)}`
      } else {
        co = address.nameAddition
      }
    } else if (employee.contact.firstName) {
      co = `${intl.formatMessage({
        id: 'attn',
      })} ${getFullContactName(employee.contact)}`
    } else {
      co = ''
    }

    radioButtons.shift()

    if (portalConfig?.shipToOfficeAddress) {
      radioButtons.push({
        label: `${employee.office?.organisation?.shortName} Office ${employee.office?.locationName}`,
        shippingAddress: {
          city: address.city,
          co,
          country: address.country,
          id: address.id,
          postcode: address.zipcode,
          to: address.name || '',
          type: ShippingAddressTypeEnum.OFFICE,
          ...splitStreetNumber(address.street || ''),
        },
        shippingAddressCanBeEdited: true,
      })
    }
  }

  if (portalConfig?.shipDeviceToCustomAddress)
    if (rental.employee?.contact.address) {
      const { address } = rental.employee.contact

      let to = ''

      if (address.name) {
        to = address.name
      } else {
        to = getFullContactName(rental.employee.contact)
      }

      const customAddress = {
        label: intl.formatMessage({
          id: ADDRESSES.CUSTOM_ADDRESS_LABEL,
        }),
        shippingAddress: {
          city: address.city,
          co: address.nameAddition,
          country: address.country ? address.country : '',
          id: address.id,
          postcode: address.zipcode,
          to,
          type: ShippingAddressTypeEnum.HOME_ADDRESS,
          ...splitStreetNumber(address.street || ''),
        },
        shippingAddressCanBeEdited: true,
      }

      if (portalConfig?.customDeliveryAddress) {
        radioButtons.unshift(customAddress)
      } else {
        radioButtons.push(customAddress)
      }
    } else {
      const customAddress = {
        isCustom: true,
        label: intl.formatMessage({
          id: ADDRESSES.CUSTOM_ADDRESS_LABEL,
        }),
        shippingAddress: {
          city: '',
          co: '',
          country: '',
          id: '0',
          isCustom: true,
          postcode: '',
          street: '',
          streetNumber: '',
          to: '',
          type: ShippingAddressTypeEnum.HOME_ADDRESS,
        },
        shippingAddressCanBeEdited: true,
      }

      if (portalConfig?.customDeliveryAddress) {
        radioButtons.unshift(customAddress)
      } else {
        radioButtons.push(customAddress)
      }
    }

  return radioButtons
}
